const cancel = 'Odustani'
const save = 'Spremi'

export default {

  global: {
    generalError: 'O, ne! Zahtjev se nije moglo obraditi. Ponovno učitajte stranicu.',
    signature: 'Srdačan pozdrav,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Dodajte životopis ili neke druge privitke',
      placeholderWithDescription: 'Dodajte tražene privitke',
      remove: 'Ukloni',
      allowedFileTypes: 'Dopuštene vrste datoteka',
      errors: {
        size: 'Dadoteka je prevelika. Najveća dopuštena veličina iznosi 5MB.',
        empty: 'Nema podataka u datoteci',
        invalidType: fileType => `Žao nam je, ${fileType} datoteke nisu dozvoljene zbog sigurnosnih razloga`,
        typeNotWhitelisted: 'Ispričavamo se, ali ova se vrsta datoteke ne podržava.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Pravila o zaštiti osobnih podataka',
      termsLinkText: 'Uvjete i odredbe',
      privacyPolicyText: 'Vaša privatnost nam je važna. Molimo da pročitate naša ',
      termsText1: 'Pročitajte i prihvatite ',
      termsText2: 'prije nego što nam predate osobne podatke.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Ako ne želite da obrađujemo vaše osobne podatke, možete zatražiti uklanjanje podataka slanjem e-poruke na ${mail}.`,
      customSupportPrivacyInfo: link => `Ha nem akarja, hogy adatait felhasználjuk, kérheti törlésüket a ${link} címen.`,
    },

    buttons: {
      close: 'Zatvori',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Ukloni pokušaj',
      confirm: 'Pokušaj ponovno',
    },

    confirmButton: {
      wait: count => `Pričekajte ${count}`,
      confirm: 'Potvrdi',
    },

    controlStatus: {
      text: {
        empty: 'Ispuni',
        valid: () => 'Spremno',
      },
      textarea: {
        empty: 'Ispuni',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Odredi',
        valid: () => 'Spremno',
      },
      file: {
        empty: 'Odaberi',
        valid: () => 'Pomijeni',
      },
      list: {
        empty: 'Dodaj',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Pretraži',
        valid: () => 'Spremno',
      },
    },

    cookieConsentModal: {
      title: 'Naše internetske stranice koriste kolačiće',
      body: 'Prihvaćanjem svih kolačića pristajete na pohranjivanje kolačića na vašem uređaju kako biste poboljšali vaše kretanje internetskim stranicama, analizu korištenja stranice i pomogli u našem marketingu.',
      learnMoreLinkText: 'Saznajte više o tome kako koristimo kolačiće',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Upravljanje kolačićima',
      acceptAll: 'Prihvati sve kolačiće',
      manageTitle: 'Upravljanje postavkama privole',
      necessaryCookiesTitle: 'Nužni kolačići',
      necessaryCookiesBody:
        'Kolačići koji su nužni za funkcioniranje internetskih stranica i u našim sustavima ne mogu se isključiti.',
      performanceCookiesTitle: 'Kolačići za pospješenje učinkovitosti',
      performanceCookiesBody:
        'Ovi nam kolačići omogućuju brojenje posjeta i izvora prometa kako bismo mogli izmjeriti i poboljšati učinak koji naše stranice postižu.',
      confirmChoices: 'Potvrdi moje izbore',
      marketingCookiesTitle: 'Marketinški kolačići',
      marketingCookiesBody:
        'Ovim nam se kolačićima omogućava prilagođavanje oglasa i mjerenje izvedbe oglasa.',
      functionalCookiesTitle: 'Kolačići funkcionalnosti',
      functionalCookiesBody:
        'Ovi se kolačići upotrebljavaju za poboljšanje funkcionalnosti mrežnog mjesta. Bez ovih kolačića određene funkcije mogu biti nedostupne. Primjeri funkcionalnih kolačića uključuju usluge mrežnog čavrljanja i korisničke postavke.',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Ukloni',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Zabranjeno',
      content: 'Naš je poslužitelj ljubazno (ali definitivno) odbio ispuniti zahtjev vašeg preglednika. Molimo, imajte na umu da se Recright mora upotrebljavati samo na jednom uređaju/pregledniku (istovremeno).',
      link: 'Naslovna stranica',
    },

    error404: {
      heading: 'Ovdje nema ništa',
      content: 'Stvarno smo se potrudili, ali na traženoj adresi nismo pronašli web-stranicu. Možda ste kliknuli na poveznicu kojoj je istekla valjanost ili ste slučajno upisali pogrešnu adresu.',
      link: 'Naslovna stranica',
    },

    error410: {
      heading: 'Zatvoreno',
      content: 'Posao se ne prikazuje jer je zatvoren ili je isteklo razdoblje za prijavu.',
      link: 'Naslovna stranica',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inicijalizacija...',
      connection_error_hint: 'Nije se moglo uspostaviti mrežnu vezu.\nPokušajte ponovno učitati stranicu.',
      permission_hint: 'Ova stranica traži dopuštenje za upotrebu vaše web-kamere i mikrofona.',
      searching_camera_hint: 'Traženje web-kamere...',
      camera_reserved_hint: 'Vašu je web-kameru rezervirala neka druga aplikacija ili web-stranica.\nZatvorite aplikaciju i ponovno učitajte ovu stranicu.',
      camera_reserved_hint_chrome_extra: 'Poštovani korisniče preglednika Chrome, morate dopustiti programu Recright upotrebu vaše web-kamere u dijalogu ispod adresne trake.',
      no_camera_hint: 'Nismo mogli pronaći web-kameru.',
      no_mic_hint: 'Nismo mogli pronaći mikrofon.',
      uploading_text: 'Prijenos u tijeku...',
      rtmpt_in_use: 'Ovaj korak ne bi bio potreban da je vaš mrežni\nadministrator omogućio RTMP-protokol. Pitajte nas kako.',
      preview_text: 'Web-kamera je u načinu pretpregleda',
      close_text: 'Zatvori kameru',
      remove_text: 'Ukloni pokušaj',
      noflash_errortext_install: link => `Izgleda da nemate program Adobe Flash Player. Za snimanje videozapisa potreban je flash dodatak. Preuzmite flash ovdje: ${link}`,
      noflash_errortext_enable: link => `Ako ste već instalirali flash, ali i dalje vidite ovu poruku, pogledajte ovo: ${link}`,
      noflash_errortext_differentbrowser: 'Također možete pokušati putem preglednika koji pdržava snimanje jezikom HTML5. Predlažemo Chrome ili Firefox.',
    },

    footer: {
      terms: 'Uvjeti',
      license: 'General Terms of Service',
      privacyPolicy: 'Pravila zaštite privatnosti',
      customSupport: link => `Kontaktirajte ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Kako biste opisali svoj doživljaj intervjua?',
      howWouldYouRateJobAd: 'Kako biste ocjenili svoje iskustvo prijave?',
      yourResponseIsAnonymous: 'Vaš odgovor je anoniman.',
      thankYouFeedback: 'Hvala vam na povratnim informacijama!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Ispričavamo se, ali ova se vrsta datoteke ne podržava.',
      isRequired: 'Ovo je polje obavezno.',
      isEmail: value => `${value} nije ispravna adresa e-pošte.`,
      isDate: value => `${value} nije ispravan datum.`,
      invalidUrl: 'URL nije ispravan.',
      singleHireEndError: 'Usluga za jedan postupak zapošljavanja ne može se upotrebljavati više od 60 dana.',
      isNotTooOldForLive: 'Datum pripada prošlosti.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Ime',
      city: 'Grad',
      email: 'E-pošta',
      phone: 'Broj telefona',
      applyForPosition: 'Prijava za posao',
      back: 'Natrag',
      continue: 'Nastavi',
      submit: 'Pošalji',
      saveForLater: 'Nastavi poslije',
      namePlaceholder: 'Upišite ime',
      emailPlaceholder: 'Upišite e-adresu',
      phonePlaceholder: 'Upišite broj telefona',
      cityPlaceholder: 'Upišite ime trenutnog grada stanovanja',
      links: 'Dodajte poveznice, na primjer na vaš profil na LinkedInu.',
      legendBasicInfo: 'Osnovne informacije',
      legendLinks: 'Poveznice',
      legendAttachments: 'Privici',
      legendAdditionalFields: 'Dodatne informacije',
      coverLetter: 'Popratno pismo',
      attachments: 'Privici',
      introduction: 'Ovdje se kratko predstavite',
      thankYou: 'Hvala.',
      luck: 'Sretno!',
      close: 'Zatvori',
      required: 'Stvake označene zvjezdicom (*) potrebno je ispuniti.',
    },

    jobAdContainer: {
      endTime: date => (date ? `otvoreno do ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Prijavi se za posao',
    },

    jobAdQuickInterview: {
      back: 'Natrag',
      submit: 'Pošalji',
      saveForLater: 'Nastavi poslije',
      title: 'Brzi videorazgovor',
      description: 'Da bismo vas što brže upoznali, željeli bismo da ukratko odgovorite na naše kratko pitanje. Ne zaboravite pokazati svoju osobnost i dati svojoj prijavi dušu.',
      requiredNote: 'Ne zaboravite da je ovo dio postupka prijave. Službenik za kadrovske poslove primit će vašu prijavu tek nakon što snimite svoj odgovor.',
      reminderNote: 'Odgovor možete snimiti odmah ili možete nastaviti poslije odabirom opcije primanja podsjetnika e-poštom.',
    },

    jobAdRow: {
      responses: 'Prijave',
      status: {
        open: 'Otvoreno',
        filled: 'Ispunjeno',
        cancelled: 'Otkazano',
        done: 'Gotovo',
        close: 'Zatvori',
        draft: 'Zatvoreno (nacrt)',
        hidden: 'Skriveno',
      },
    },

    interviewRow: {
      responses: 'Kandidati',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Pokaži LinkedIn profil',
    },

    linkedInButton: {
      error: 'Greška pri uvozu profila. Molimo pokušajte ponovo.',
      buttonText: 'Prijavite se putem LinkedIna',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Možete upotrijebiti Vaš LinkedIn profil za ispunjavanje obrasca za prijavu',
      linkedInOr: 'Ili',
      error: 'Greška pri uvozu profila. Molimo pokušajte ponovo.',
    },

    linkListInput: {
      addField: 'Dodaj',
      removeField: 'Ukloni',
      invalidUrl: 'URL nije ispravan.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Učitavanje...',
      saving: 'Spremanje...',
      sending: 'Slanje...',
    },

    modalApplicationForm: {
      applyForPosition: 'Prijava za posao',
      continue: 'Nastavi',
      name: 'Upišite ime',
      email: 'Upišite e-adresu',
      phoneNumber: 'Upišite broj telefona',
      links: 'Možete unijeti poveznice',
      legendLinks: 'Poveznice',
      legendAttachments: 'Privici',
      coverLetter: 'Popratno pismo',
      attachments: 'Privici',
      introduction: 'Ovdje se kratko predstavite',
      thankYou: 'Hvala.',
      luck: 'Sretno!',
      close: 'Zatvori',
    },

    modalConfirm: {
      cancel,
      confirm: 'U redu',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Djeljiva javna poveznica',
      info: 'Ovo je javna adresa oglasa za posao koju možete podijeliti.\nSvi zainteresirani za to radno mjesto mogu vidjeti oglas\ni odlučiti žele li se prijaviti ili ne.\nPoslat ćemo vam uobičajenu obavijest kada prijave počinju pristizati.\n\nEvo javne poveznice za oglas za posao:',
    },

    modalVideoAdd: {
      title: 'Dodaj novi videozapis',
      chooseTitle: 'Dodaj novi videozapis',
      titlePlaceholder: 'Ovdje upišite naziv videozapisa',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Prenesi novi videozapis',
      info: 'Najveća dopuštena veličina videodatoteke iznos 500 MB. Preporučujemo komprimiranje videodatoteka prije prenošenja jer će u tom slučaju prenošenje i konverzija biti brži.',
    },

    modalCandidateInfo: [
      {
        headline: 'Snimite odgovor na videozapis ',
        content: 'koliko god puta želite. Videozapisi se spremanju odmah nakon snimanja. Na videorazgovor se možete vratiti putem poveznice koju ste primili e-poštom.',
        mobileContent: 'koliko god puta želite. Dodajte videozapis razgovoru. Vidjet ćete kako se videozapis prenosi i sprema u razgovor. Na videorazgovor se možete vratiti putem poveznice koju ste primili e-poštom. <br><br><strong>Ako na zaslonu vašeg Apple mobilnog uređaja nema slike, upute za otklanjanje poteškoće potražite <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">ovdje</a>.</strong>',
      },
      {
        headline: 'Nakon snimanja ',
        content: 'provjerite reproducira li se videozapis ispravno i čuje li se vaš glas. Nakon što pritisnete gumb „Pošalji”, vaši će odgovori biti zaključani i nećete ih više moći uređivati.',
      },
      {
        headline: 'Kada završite s razgovorom, ',
        content: 'pritisnite gumb „Pošalji odgovore i završi razgovor”. Nakon toga više se nećete moći vratiti na videorazgovor. Ako želite zatvoriti ovu stranicu i poslije se vratiti na razgovor, pritisnite gumb „Nastavi poslije”.',
      },
      {
        headline: 'Ako vam je potrebna pomoć ',
        content: mailto => `pri odgovaranju na pitanja u videorazgovoru, pritisnite gumb „Pomoć” u donjem desnom kutu stranice ili nam poštaljite e-poruku na ${mailto}.`,
        customContent: link => `Kontaktirajte ${link}`,
      },
    ],

    navigationBar: {
      back: 'Natrag',
      dashboard: 'Nadzorna ploča',
      frontpage: 'Naslovna stranica',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefon u formatu ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Prosječna ocjena',
      reset: 'resetirati',
    },

    share: {
      share: 'Podijeli',
      copy: 'Kopiraj poveznicu',
    },

    sort: {
      sort: 'Sortiraj',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Odabrani',
      change: 'Promijeni',
    },

    video: {
      videoNotFound: 'Videozapis se obrađuje ili nije pronađen',
      retry: 'Pokušaj ponovno',
      originalLanguageLabel: 'Izvornik',
      englishLanguageLabel: 'Engleski',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Prenesi ili snimi novi videozapis' : 'Odaberi datoteku'),
      videoPlaceholder: 'Snimi svoj odgovor',
      uploadPlaceholderCandidate: 'Prenesi videozapis',
      submit: 'Pošalji odgovor',
      notAnswered: 'Još niste odgovorili',
      remove: 'Ukloni pokušaj',
      converting: 'Videozapis se konvertira. Pričekajte trenutak...',
      uploading: 'Videozapis se prenosi. Pričekajte trenutak...',
      error: {
        invalid: 'Odabrana je datoteka prevelika. Odaberite drugu datoteku.',
        upload: 'Žao nam je, ali nismo mogli prenijeti videozapis. Pokušajte ponovno.',
        transcode: 'Odabrana videodatoteka bila je oštećena ili neispravna. Pokušajte ponovno.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Prikaži više',
      showLessButtonText: 'Prikaži manje',
      infoText1:
        'Aktivna karticu tijekom snimanja zadržite u prednjem planu. Tijekom snimanja ne biste smjeli upotrebljavati nijednu drugu aplikaciju.',
      infoText2:
        'Videozapisi upotrebljeni kao pozadina najbolje rezultate daju s novijim preglednicima i na uređajima koji su noviji i snažniji.',
      infoText3:
        'Osigurajte da nijedna druga aplikacija ne upotrebljavaju ni vaš mikrofon ni kameru.',
    },

    videoResponse: {
      videoPlaceholder: 'Snimi svoj odgovor',
      uploadPlaceholder: 'Prenesi videozapis',
      submit: 'Pošalji odgovor',
      notAnswered: 'Još niste odgovorili',
      required: 'Ovo pitanje zahtijeva odgovor',
      startInterview: 'Započni razgovor',
    },

    webcam: {
      useVideoBgButtonText: 'Kao pozadinu upotrijebi videozapis',
      removeVideoBgButtonText: 'Ukloni videozapis upotrebljen kao pozadina',
      starting: 'Pokretanje...',
      close: 'Zatvori kameru',
      remove: 'Ukloni pokušaj',
      record: 'Snimi',
      stop: 'Zaustavi',
      retake: 'Ponovno pokušaj',
      submit: 'Pošalji odgovor',
      converting: 'Videozapis se konvertira. Pričekajte trenutak...',
      uploading: 'Videozapis se prenosi. Pričekajte trenutak...',
      downloading: 'Videozapis se preuzima. Pričekajte trenutak...',
      processing: 'Obrada...',
      uploadInProgress: 'Prijenos videozapisa još uvijek traje, pa nemojte zatvoriti preglednik ni promijeniti stranicu.',
      uploaded: 'Videozapis je prenesen.',
      error: {
        DevicesNotFoundError: 'Upotreba kamere ili mikrofona nije moguća. Provjerite jesu li uključeni.',
        NotFoundError: 'Upotreba kamere ili mikrofona nije moguća. Provjerite jesu li uključeni.',
        NotAllowedError: 'Niste dali dopuštenje za upotrebu kamere ili mikrofona.',
        PermissionDismissedError: 'Zatvorili ste dijaloški okvir za dopuštenje. Dajte dopuštenje za upotrebu kamere i mikrofona.',
        PermissionDeniedError: 'Uskratili ste pristup kameri ili mikrofonu.',
        NotReadableError: 'Nije moguće pročitati strujanje kamere ili mikrofona. Mogući hardverski problem.',
        SecurityError: 'Upotreba kamere ili mikrofona nije moguća zbog sigurnosne pogreške',
        stream: 'Došlo je do pogreške. Ponovno pokrenite svoj preglednik. Ako se problem nastavi, pokušajte otvoriti u drugom pregledniku.',
        download: 'Preuzimanje videozapisa nije uspjelo. Želite li pokušati ponovno?',
        upload: 'Prenošenje videozapisa nije uspjelo. Želite li pokušati ponovno?',
        emptyBlob: 'Memorija vašeg preglednika ili uređaja puna je i ne može snimati. Osvježite stranicu i ako to ne pomogne, ponovno pokrenuti preglednik. Ako se problem nastavi, pokušajte otvoriti u drugom pregledniku.',
        alternativeRecorder: 'Datoteku možete prenijeti i tako da kliknete na ovo.',
        reconnecting: 'Veza je prekinuta. Pokušaj ponovnog uspostavljanja veze.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Pozdrav! Pozivamo vas na intervju putem videopoziva ${title}! Ova je pozivnica poslana i na vašu adresu e-pošte. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
